import React from 'react';
import {
    FaMountainCity,
    FaArrowUpFromGroundWater,
    FaCompassDrafting,
    FaTrowelBricks,
    FaHelmetSafety,
} from 'react-icons/fa6';
import { BiCheckShield } from 'react-icons/bi';
import { BsArrowRight, BsBrightnessAltHigh, BsFileEasel } from 'react-icons/bs';
import mainImg from "../assets/img/alt-services.jpg";
import { useTranslation } from 'react-i18next';

const Welcome = () => {

        const { t } = useTranslation();
    
        // Dynamic services data - now using translations
        const welcome = [
            {
                id: 1,
                icon: <FaMountainCity />,
                title: t('key-company-welcome.items.1.title'),
                description: t('key-company-welcome.items.1.description'),
                delay: 100,
            },
            {
                id: 2,
                icon: <FaArrowUpFromGroundWater />,
                title: t('key-company-welcome.items.2.title'),
                description: t('key-company-welcome.items.2.description'),
                delay: 200,
            },
            {
                id: 3,
                icon: <FaCompassDrafting />,
                title: t('key-company-welcome.items.3.title'),
                description: t('key-company-welcome.items.3.description'),
                delay: 300,
            },
                        {
                id: 4,
                icon: <FaCompassDrafting />,
                title: t('key-company-welcome.items.4.title'),
                description: t('key-company-welcome.items.4.description'),
                delay: 300,
            }
        ];
    
        // Dynamic icon boxes - now using translations
        // const iconBoxes = [
        //     {
        //         id: 1,
        //         icon: <BsFileEasel className="flex-shrink-0" />,
        //         title: t('services.alt.boxes.1.title'),
        //         link: '#',
        //         description: t('services.alt.boxes.1.description'),
        //         delay: 300,
        //     },
        //     {
        //         id: 2,
        //         icon: <BiCheckShield className="flex-shrink-0" />,
        //         title: t('services.alt.boxes.2.title'),
        //         link: '#',
        //         description: t('services.alt.boxes.2.description'),
        //         delay: 400,
        //     },
        //     {
        //         id: 3,
        //         icon: <BsBrightnessAltHigh className="flex-shrink-0" />,
        //         title: t('services.alt.boxes.3.title'),
        //         link: '#',
        //         description: t('services.alt.boxes.3.description'),
        //         delay: 500,
        //     },
        //     {
        //         id: 4,
        //         icon: <BsBrightnessAltHigh className="flex-shrink-0" />,
        //         title: t('services.alt.boxes.4.title'),
        //         link: '#',
        //         description: t('services.alt.boxes.4.description'),
        //         delay: 600,
        //     },
        // ];

    return (
          <>
                   {/* Services Section */}
                   <section id="services" className="services section light-background">
                       {/* Section Title */}
                       <div className="container section-title" data-aos="fade-up">
                           <h2>{t('key-company-welcome.title')}</h2>
                           <p>{t('key-company-welcome.subtitle')}</p>
                       </div>
       
                       <div className="container">
                           <div className="row gy-4">
                               {welcome.map(({ id, icon, title, description, delay }) => (
                                   <div
                                       key={id}
                                       className="col-lg-4 col-md-6"
                                       data-aos="fade-up"
                                       data-aos-delay={delay}
                                   >
                                       <div className="service-item position-relative">
                                           <div className="icon">{icon}</div>
                                           <h3>{title}</h3>
                                           <p>{description}</p>
                                           <a href="#" className="readmore stretched-link">
                                               {t('key-company-welcome.readMore')} <BsArrowRight />
                                           </a>
                                       </div>
                                   </div>
                               ))}
                           </div>
                       </div>
                   </section>
               </>
    )
}

export default Welcome
